import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Instagram from '../../homepage/components/instagram/Instagram';
import JoinNow from '../../homepage/components/join_now/JoinNow';

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Provider store={window.store}>
      <JoinNow />
    </Provider>,
    document.getElementById('join-now'),
  );

  const instagramElement = document.getElementById('instagram');
  const { token } = instagramElement.dataset;

  ReactDOM.render(
    <Instagram token={token} />,
    instagramElement,
  );

  const StickyCategories = React.lazy(() => import('../../homepage/components/sticky_categories/StickyCategories'));
  ReactDOM.render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
    document.getElementById('react-sticky-categories'),
  );

  AOS.init();
});
